import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { PageLayout } from "../components/PageLayout";
import { Reveal } from "../components/Reveal";
import { CtaBanner } from "../components/CtaBanner";

const POINTS = [
    "Ein Ansprechpartner für alles – von der Anfrage bis zur Ausführung",
    "Verbindliche Termine und transparente Festpreise",
    "Professionelle Motorgeräte, u. a. von STIHL und Husqvarna",
    "Saubere Arbeit: Schnittgut und Laub nehme ich direkt mit",
    "Regional verwurzelt – schnell vor Ort im gesamten Landkreis Celle",
];

export const UeberMich = () => (
    <PageLayout>
        <section className="pt-28 lg:pt-40 pb-16 lg:pb-24 px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
                <Reveal>
                    <p className="font-mono text-xs uppercase tracking-[0.25em] text-leaf font-semibold mb-4">
                        Über mich · Celle
                    </p>
                    <h1 className="font-display font-bold tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl leading-[1.1]">
                        Julian Kosinski – persönlich, regional, zuverlässig.
                    </h1>
                    <p className="mt-6 text-base sm:text-lg text-shade leading-relaxed">
                        Ich bin der Inhaber von Julians Gartenservice und arbeite im Landkreis Celle.
                        Bei mir gibt es keine wechselnden Teams und keine Hotline: Sie sprechen immer
                        direkt mit dem, der die Arbeit auch ausführt – vom ersten Anruf bis zum letzten
                        Handgriff.
                    </p>
                    <p className="mt-4 text-base sm:text-lg text-shade leading-relaxed">
                        Mein Anspruch ist einfach: saubere Arbeit, verbindliche Termine und Ergebnisse,
                        die man sofort sieht. Dafür arbeite ich mit professioneller Technik und nehme
                        mir die Zeit, die ein Grundstück braucht – nicht mehr und nicht weniger.
                    </p>
                </Reveal>
                <Reveal delay={0.1}>
                    <img
                        src="/leistung-heckenschnitt.webp"
                        alt="Julian Kosinski von Julians Gartenservice bei der Arbeit mit der Heckenschere in Celle"
                        className="w-full aspect-[4/3] object-cover rounded-3xl shadow-[0_30px_80px_-30px_rgba(24,59,43,0.4)]"
                    />
                </Reveal>
            </div>

            <div className="mt-16 lg:mt-24 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
                <Reveal className="order-2 lg:order-1">
                    <img
                        src="/leistung-rasenpflege.webp"
                        alt="Julian Kosinski bei der Rasenpflege mit dem Aufsitzmäher im Landkreis Celle"
                        className="w-full aspect-[4/3] object-cover rounded-3xl shadow-[0_30px_80px_-30px_rgba(24,59,43,0.4)]"
                        loading="lazy"
                    />
                </Reveal>
                <Reveal delay={0.1} className="order-1 lg:order-2">
                    <h2 className="font-display font-semibold tracking-tight text-ink text-2xl sm:text-3xl">
                        So arbeite ich
                    </h2>
                    <ul className="mt-6 space-y-4">
                        {POINTS.map((p) => (
                            <li key={p} className="flex items-start gap-3 text-base text-ink">
                                <span className="mt-1 w-6 h-6 rounded-full bg-leaf/15 text-leaf flex items-center justify-center shrink-0">
                                    <Check size={14} strokeWidth={3} />
                                </span>
                                {p}
                            </li>
                        ))}
                    </ul>
                    <Link
                        to="/angebot"
                        data-testid="ueber-mich-cta"
                        className="mt-9 inline-flex items-center gap-2.5 bg-leaf hover:bg-forest text-white font-semibold px-7 py-4 rounded-full text-base transition-colors duration-200"
                    >
                        Sprechen wir über Ihr Grundstück
                        <ArrowRight size={17} strokeWidth={2.4} />
                    </Link>
                </Reveal>
            </div>
        </section>

        <CtaBanner title="Lernen wir uns kennen – am besten bei Ihrem Grundstück." />
    </PageLayout>
);
